import classNames from 'classnames';
import { format as defaultFormat } from '~/components/Util/number';

export type DonProps = {
  value?: number;
  className?: string;
  format?: (value?: number) => string | number | undefined;
};

const defaultOptions = {
  decimalPlaces: 0,
  roundingMode: undefined,
  postfix: '',
};

export const Don = ({ value, className, format }: DonProps) => {
  const defaultFormatted = defaultFormat(value, defaultOptions);
  const formatted = format ? format(value) : defaultFormatted;
  return <span className={classNames('don', className)}>{formatted}</span>;
};
